module.exports = __webpack_public_path__ + "img/zutuun_partner.jpg";